import React from 'react';
import { useStaticQuery, graphql } from 'gatsby';
import Button from 'src/app/atoms/Button/Button';
import Stack from 'src/app/atoms/Layout/Stack/Stack';
import Typography from 'src/app/atoms/Typography/Typography';
import HeadingAndSupportingTextWithActions from 'src/app/molecules/HeadingAndSupportingText/HeadingAndSupportingTextWithActions';
import ImageAndContent from 'src/app/molecules/ImageAndContent/ImageAndContent';
import { IStaticContentfulImages } from 'src/types/contentful';

const PeopleMagicImageAndContent = (): JSX.Element => {
  const images = useStaticQuery<IStaticContentfulImages>(graphql`
    {
      featuredImage: contentfulAsset(contentful_id: { eq: "6N4rvk9Ph1FNUtAuO7Jkpb" }) {
        gatsbyImageData(layout: CONSTRAINED, placeholder: BLURRED, width: 1700)
      }
    }
  `);

  return (
    <Stack
      margin={['spacing-none', 'spacing-auto']}
      justify='center'
      align='center'
    >
      <ImageAndContent
        image={{
          imageProps: {
            image: images.featuredImage.gatsbyImageData,
            alt: 'Member Engagement',
          },
          maxWidth: 650,
          radius: 'radius-2xl',
        }}
        contentPosition='right'
        content={
          <Stack
            padding={['spacing-none', 'spacing-4xl']}
            paddingMd='spacing-none'
            direction='column'
            gap='spacing-4xl'
          >
            <HeadingAndSupportingTextWithActions
              maxWidth='width-2xl'
              gap='spacing-3xl'
              direction='column'
              subHeadingGap='spacing-lg'
              heading={{
                type: 'heading',
                text: 'Member Engagement',
                size: 'lg',
                letterSpacing: -1,
                fontWeight: 'font-weight-semibold',
              }}
              subHeading={{
                text: 'People Magic',
                size: 'md',
                type: 'paragraph',
                color: 'text-brand-secondary',
                fontWeight: 'font-weight-semibold',
              }}
              supportingText={{
                type: 'paragraph',
                size: 'xl',
                color: 'text-tertiary',
                children: (
                  <Stack
                    direction='column'
                    gap='spacing-lg'
                    as='span'
                  >
                    <Typography
                      as='span'
                      text="Your members don't just consume content on Mighty. They meet each other. They build relationships. They come back."
                    />
                    <Typography
                      as='span'
                      text="84% of content on Mighty is created by members, not hosts. 59% of active members return weekly. That's how you get 80%+ revenue retention without email marketing."
                    />
                  </Stack>
                ),
              }}
              actions={
                <Stack
                  maxWidth='width-fit-content'
                  marginTop='spacing-4xl'
                >
                  <Button
                    variant='primary'
                    size='xl'
                    href='https://cohost.mn.co/?plan=free-trial'
                  >
                    Try Mighty for Free
                  </Button>
                </Stack>
              }
            />
          </Stack>
        }
      />
    </Stack>
  );
};

export default PeopleMagicImageAndContent;
